/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function getNetworkType(params) {
    // https://h5.alibaba-inc.com/api/WindVane-API.html#WVNetwork-getNetworkType
    var formatOutput = function (ret) {
        var type = "".concat(ret === null || ret === void 0 ? void 0 : ret.type);
        switch (type) {
            case 'WIFI':
            case '5G':
            case '4G':
            case '3G':
            case '2G':
                break;
            case 'CELL':
            case 'UNKNOWN':
            default:
                type = 'UNKNOWN';
                break;
        }
        return { networkType: type };
    };
    WVCall('WVNetwork.getNetworkType', params, { formatOutput: formatOutput });
}

export { getNetworkType as default };
